import Swiper from '../../node_modules/swiper/swiper-bundle.js';

const bannerCarousel = () => {
  const items = document.querySelectorAll('.banner-carousel');
  if (items.length <= 0) return;
  items.forEach((item) => {
    const itemId = item.dataset.slider;
    const swiperInstance = new Swiper(`[data-slider="${itemId}"]`, {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: `[data-arrow-next="${itemId}"]`,
        prevEl: `[data-arrow-prev="${itemId}"]`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      loop: true,
      autoplay: {
        delay: 10000,
      },
    });
    item.addEventListener('mouseover', () => {
      swiperInstance.autoplay.stop();
    });

    item.addEventListener('mouseout', () => {
      swiperInstance.autoplay.start();
    });

    item.addEventListener(
      'touchstart',
      () => {
        swiperInstance.autoplay.stop();
      },
      { passive: true }
    );

    // Optionally, restart autoplay on touch end
    item.addEventListener(
      'touchend',
      () => {
        swiperInstance.autoplay.start();
      },
      { passive: true }
    );
  });
};

const announcementCarousel = () => {
  new Swiper('[data-slider="announcement"]', {
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: `[data-arrow-next="announcement"]`,
      prevEl: `[data-arrow-prev="announcement"]`,
    },
    loop: true,
    autoplay: {
      delay: 20000,
    },
  });
};

export const swiper = () => {
  bannerCarousel();
  announcementCarousel();
};
